module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPages > 1),
      expression: "totalPages > 1"
    }],
    staticClass: "comp-pager"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('a', {
    staticClass: "item-link",
    attrs: {
      "href": "javascript:;",
      "aria-label": "Previous"
    },
    on: {
      "click": function($event) {
        _vm.selectPage(_vm.currentPageNo - 1)
      }
    }
  }, [_vm._m(0)])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "item",
      class: {
        'active': page.number == _vm.currentPageNo, 'disabled': page.disabled
      }
    }, [_c('a', {
      staticClass: "item-link",
      attrs: {
        "href": "javascript:;"
      },
      domProps: {
        "textContent": _vm._s(page.text)
      },
      on: {
        "click": function($event) {
          _vm.selectPage(page.number)
        }
      }
    })])
  }), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('a', {
    staticClass: "item-link",
    attrs: {
      "href": "javascript:;",
      "aria-label": "Next"
    },
    on: {
      "click": function($event) {
        _vm.selectPage(_vm.currentPageNo + 1)
      }
    }
  }, [_vm._m(1)])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "icon-left"
  }), _vm._v("<")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "icon-right"
  }), _vm._v(">")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23850f50", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23850f50!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pager.vue
// module id = 29
// module chunks = 0 1